/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://ciijl5qs3jcgbkvaw5lkpb4u2q.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-gzi2rw6xfvbnxexoz4bsrp2aoq",
    "aws_cloud_logic_custom": [
        {
            "name": "stockSMSAPI",
            "endpoint": "https://uu17gssrcf.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:a091110b-ccea-4d44-a6c4-a43b95f1d39b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_rEmAx9Pob",
    "aws_user_pools_web_client_id": "25362370c5i3ki0sf57a4dhpug",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "palettebackend1405165f631648bda7834758067807e27e89f-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
